import { createFileRoute, redirect } from '@tanstack/react-router'
import { ETransferInstructions } from '@web/src/features/supporter/e-transfer-instructions/e-transfer-instructions'
import { env } from '@web/src/lib/env.client'
import { z } from 'zod'

/** Query params can arrive as string | string[] depending on parser / duplicate keys. */
function normalizeSearchAmount(value: unknown): string | undefined {
  if (value == null || value === '') return undefined
  if (Array.isArray(value)) {
    return normalizeSearchAmount(value[0])
  }
  if (typeof value === 'string') {
    const t = value.trim()
    return t.length > 0 ? t : undefined
  }
  const s = String(value).trim()
  return s.length > 0 ? s : undefined
}

const searchSchema = z.object({
  amount: z.preprocess(normalizeSearchAmount, z.string().optional()),
})

export const Route = createFileRoute('/(auth)/(main-layout)/supporter/e-transfer-instructions')({
  validateSearch: searchSchema,
  staticData: {
    hideFooter: true,
  },
  beforeLoad: ({ search }) => {
    const amount = normalizeSearchAmount(search.amount)
    if (!amount) {
      throw redirect({ to: '/supporter' })
    }
  },
  head: () => ({
    meta: [
      { title: `E-Transfer Instructions | ${env.VITE_APP_NAME}` },
      { name: 'description', content: 'Complete your supporter payment via Interac e-Transfer' },
      { name: 'robots', content: 'noindex,nofollow' },
    ],
  }),
  component: ETransferInstructionsRoute,
})

function ETransferInstructionsRoute() {
  const { amount } = Route.useSearch()
  const normalized = normalizeSearchAmount(amount)
  if (!normalized) {
    return null
  }
  return <ETransferInstructions amountDollars={normalized} />
}
